import React, { FunctionComponent, useCallback, FormEvent } from 'react';
import styled from 'styled-components';

import { CardList, SubmitButton } from 'components';
import { Heading } from 'components/chroma';

import { getAdditionalDrivers, getMainDriver } from 'scenes/motor/selectors';
import { MotorFullPageProps } from 'scenes/motor/types';
import analytics from 'scenes/motor/analytics';

import { DriverCard } from './DriverCard';
import { hasName } from './service/validation';

const ButtonWrapper = styled.div`
  margin-top: 1.5rem;
`;

const ReviewDriverDetailsStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onNext,
  onUpdateDriver,
}) => {
  const mainDriver = getMainDriver(funnelState);
  const additionalDrivers = getAdditionalDrivers(funnelState);
  const onSubmit = useCallback(
    (event: FormEvent) => {
      analytics().retrieveQuoteComplete(funnelState);
      onNext({});
      event.preventDefault();
    },
    [funnelState, onNext]
  );

  const isValid =
    hasName(mainDriver) && additionalDrivers.every((driver) => hasName(driver));

  return (
    <form onSubmit={onSubmit}>
      <Heading size={3} margin={{ top: 2 }}>
        Please add driver details below
      </Heading>
      <Heading size={4} margin={{ top: 6, bottom: 2 }}>
        Main driver
      </Heading>
      <CardList marginBottom="1rem" role="list">
        <DriverCard
          driver={mainDriver}
          onEditReviewDriver={() => onUpdateDriver()}
        />
      </CardList>
      {additionalDrivers.length > 0 && (
        <>
          <Heading size={4} margin={{ top: 7, bottom: 2 }}>{`Additional driver${
            additionalDrivers.length > 1 ? 's' : ''
          }`}</Heading>
          <CardList marginBottom="1rem" role="list">
            {additionalDrivers.map((driver, index) => (
              <DriverCard
                key={driver.dob}
                driver={driver}
                onEditReviewDriver={() => onUpdateDriver(index)}
              />
            ))}
          </CardList>
        </>
      )}
      <ButtonWrapper>
        <SubmitButton enabled={isValid}>Next</SubmitButton>
      </ButtonWrapper>
    </form>
  );
};

export default ReviewDriverDetailsStep;
